<template>
    <div class="login">
        <div class="loginMain">
            <div class="nav clearfix">
                <img class="navBack pull-left" src="../../../static/images/common/newBack.png" alt="" @click="navBack()">
            </div>
            <h2>欢迎登录优铺租铺宝</h2>
            <h5>让租铺变轻松</h5>

            <div class="dInput clearfix">
                <div class="input2 pull-left">
                    <input type="tel" placeholder="请输入手机号码" v-model="phoneVal" maxlength="13" @keyup="keyVal($event)">
                    <!-- <button type="button" :disabled="disabled" @click="sendcode" class="btns" :class="{'codeColor':chengaColor}">{{btntxt}}</button>
                    <img src="../../../static/images/login/close.png" @click="closeBtn()" class="closeBtn" v-if="isCloseBtnShow"> -->
                </div>
            </div>

            <div class="dInput clearfix">
                <div class="input2 pull-left">
                    <input type="url" v-model="imgCodeTxt" placeholder="请输入图片验证码" maxlength="4">
                    <i class="codeImgStyle" @click="changeImgCode();"><img :src="imgCodeUrl"></i>
                </div>
            </div>

            <div class="dInput clearfix" style="margin-top: .1rem;">
                <div class="input1 pull-left">
                    <input type="tel" v-model="securityCode" placeholder="请输入验证码" maxlength="6">
                    <button type="button" :disabled="disabled" @click="sendcode" class="btns" :class="{'codeColor':chengaColor}">{{btntxt}}</button>
                    <img src="../../../static/images/login/close.png" @click="closeBtn()" class="closeBtn" v-if="isCloseBtnShow">
                </div>
            </div>

            <div class="btn">
                <!-- <p>无需注册，输入手机号即可登录</p> -->
                <div class="login-btn" @click="loginBtn($event)">登录</div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from "qs";
// const base64Img = require('base64-img');
const countdown = 60;
export default {
    name: 'aboutUP',
    data () {
        return {
            phoneVal: '', // 手机号码
            securityCode: '', // 验证码
            disabled:false,
            time:0,
            btntxt:"获取验证码",
            chengaColor: false,
            formMess:{
                email:this.email,
                phone:this.phone
            },
            urlId: "",
            urlPrice: "",
            urlType: "",
            goUrl: "",
            isCloseBtnShow: false,

            imgCodeTxt: "", //图片验证码
            imgCodeUrl: "",
            uuidStr: "",

        }
    },
    computed:{

    },
    methods:{
        keyVal(e) {
            var phoneNum = this.phoneVal.trim();
            //如果是删除按键，则什么都不做
            if (e.keyCode === 8) {
              this.phoneVal = phoneNum;
              return;
            }

            var len = phoneNum.length;
            if (len === 3 || len === 8) {
              phoneNum += '-';
              this.phoneVal = phoneNum;
            }
        },

        closeBtn(){
            this.phoneVal = ""
        },

        //获取图片验证码
        imgCode() {
            let _this = this;
            // 接口调用
            let url =  _this.changeData() + '/code/view'
            axios(url,{
                method: 'get',
            }).then(data => {
                // console.log(data);
                this.imgCodeUrl = data.data.image; //图片验证码
                this.uuidStr = data.data.uuid; //uuid验证码唯一标识，提交时需要
            }).catch(err => {
                console.log(err)
            });
        },

        changeImgCode(){
            this.imgCode();
        },

        //获取验证码
        sendcode() {
            if(this.chengaColor == true){
                // this.time=60;
                // this.disabled=true;
                // this.timer();
                // 接口调用
                let _this = this
                let url =  _this.changeData() + '/sendsms'
                let str = _this.phoneVal;
                let num = str.replace(/[^0-9]/ig,"");

                axios(url,{
                    method: 'post',
                    params: {
                        phoneNumber: num,
                        cityId: sessionStorage.cityId,  //市id
                        code: this.imgCodeTxt, //图片验证码
                        uuid: this.uuidStr, 
                    }
                }).then(data => {
                    // console.log(data);
                    if(data.data.code == 101){
                        this.time=60;
                        this.disabled=true;
                        this.timer();
                    }else{
                        layer.open({
                            content: data.data.message,
                            skin: 'msg',
                            time: 2
                        });
                    }
                }).catch(err => {
                    console.log(err)
                });
            }else{
                let reg = /^1([38]\d|4[57]|5[0-35-9]|7[01-8]|9[01-9])(\-\d{4}){2}$/;
                if(this.phoneVal == ''){
                    layer.open({
                        content: '请输入手机号',
                        skin: 'msg',
                        time: 2
                    });
                }else if(!reg.test(this.phoneVal)){
                    layer.open({
                        content: '请输入正确的手机号',
                        skin: 'msg',
                        time: 2
                    });
                }else if(this.imgCodeTxt.length == ''){
                    layer.open({
                        content: '请输入图片验证码',
                        skin: 'msg',
                        time: 2
                    });
                }else if(this.imgCodeTxt.length != 4){
                    layer.open({
                        content: '图片验证码不足4位',
                        skin: 'msg',
                        time: 2
                    });
                }
            }
        },

        // 倒计时
        timer() {
            if (this.time > 0) {
                this.time--;
                // this.btntxt=this.time+"s后重新获取";
                this.btntxt= "重新获取(" + this.time + ")";
                setTimeout(this.timer, 1000);
            } else{
                this.time=0;
                this.btntxt="获取验证码";
                this.disabled=false;
            }
        },

        // 点击登录按钮
        loginBtn() {
            let reg=/^1([38]\d|4[57]|5[0-35-9]|7[06-8]|9[01-9])(\-\d{4}){2}$/;

            let _this = this;
            if(this.phoneVal==''){
               layer.open({
                    content: '请输入手机号',
                    skin: 'msg',
                    time: 2
                });
            }else if(!reg.test(this.phoneVal)){
                layer.open({
                    content: '请输入正确的手机号',
                    skin: 'msg',
                    time: 2
                });
            }else if(this.imgCodeTxt.length == ''){
                layer.open({
                    content: '请输入图片验证码',
                    skin: 'msg',
                    time: 2
                });
            }else if(this.imgCodeTxt.length != 4){
                layer.open({
                    content: '图片验证码不足4位',
                    skin: 'msg',
                    time: 2
                });
            }else if(this.securityCode == ""){
                layer.open({
                    content: '请获取短信验证码',
                    skin: 'msg',
                    time: 2
                });
            }else{
                let url = this.changeData() + '/login'
                let str = _this.phoneVal;
                let num = str.replace(/[^0-9]/ig,"");
                axios(url,{
                    method: 'post',
                    params: {
                        account: num,
                        password: _this.securityCode,
                        channel: 3,
                        provinceId: sessionStorage.provinceId,  //省id
                        cityId: sessionStorage.cityId || 110100  //市id
                    }
                }).then(data => {

                    console.log(data);

                    if(data.data.code == 101){
                        layer.open({
                            content: '登录成功',
                            skin: 'msg',
                            time: 2
                        });

                        let tel = data.data.phone;
                        window.localStorage.setItem("iphone",tel);
                        window.localStorage.setItem("token",data.data.token);
                        window.localStorage.setItem("pvCount",data.data.pvCount);
                        window.localStorage.setItem("memberType",data.data.memberType);
                        window.localStorage.setItem("userId",data.data.id);

                        // 融云token
                        // 融云id
                        window.localStorage.setItem("ryToken",data.data.rcToken);
                        window.localStorage.setItem("rcUserId",data.data.rcUserId);
                        window.localStorage.setItem("rcHeadImg",data.data.rcHeadImg);

                        _this.$store.commit("login",data.data.token);

                        var typeId = this.$route.query.shopId;
                        if(this.$route.query.shopDetail){
                            this.$router.push({path: '/shopDetail',query:{shopId: typeId}});
                        }else if(this.urlType == "wantedDetail"){
                            this.$router.push({path: '/wantedDetail',query:{id: this.$route.query.id}});
                        }else if(this.urlType == "seekShop"){
                            this.$router.push({path:"/payment",query:{"id":this.urlId,"price":this.urlPrice,"seekShop":"1"}});
                        }else if(this.urlType == "turnShop"){
                            this.$router.push({path:"/payment",query:{"id":this.urlId,"price":this.urlPrice,"turnShop":"1"}});
                        }else if(this.urlType == "message"){
                            this.$router.push({path:"/message"});
                        }else if(this.urlType == "publish"){
                            this.$router.push({path: '/publish',query:{url: _this.goUrl}});
                        }else if(this.urlType == "home"){
                            this.$router.push({path: '/home'});
                        }else {
                            this.$router.push({path: '/mine'});
                        }
                        
                        // 储存cookie
                        try{
                            function setCookie(name,value){
                                var Days = 30;
                                var exp = new Date();
                                exp.setTime(exp.getTime() + Days*24*60*60*1000);
                                // 正式环境
                                document.cookie = name + "="+ escape (value) + ";path=/;domain=.youpuchina.com;expires=" + exp.toGMTString();
                                // 测试环境
                                // document.cookie = name + "="+ escape (value) + ";path=/;domain=.yingshangchina.com;expires=" + exp.toGMTString();
                            }
                            setCookie("iphone",tel);
                            setCookie("token",data.data.token);
                            cookie.setMaxAge(365*24*60*60);
                        }catch(err){
                            console.log(err)
                        }
                        
                    }else if(data.data.code == 103){
                        layer.open({
                            content: '请输入正确验证码',
                            skin: 'msg',
                            time: 2
                        });
                    }else{
                        layer.open({
                            content: '系统繁忙，请稍后再试',
                            skin: 'msg',
                            time: 2
                        });
                    }

                }).catch(err => {
                    console.log(err)
                });
            }
        },

        navBack(){
            var typeId = this.$route.query.shopId;

            if(this.$route.query.shopDetail){
                this.$router.push({path: '/shopDetail',query:{shopId: typeId}});
            }else if(this.urlType == "wantedDetail"){
              this.$router.push({path: '/wantedDetail',query:{id: this.$route.query.id}});
            }else if(this.urlType == "seekShop"){
                this.$router.push({path: '/seekShop'});
            }else if(this.urlType == "turnShop"){
                this.$router.push({path: '/turnShop'});
            }else if(this.urlType == "message"){
                this.$router.go(-2);
            }else if(this.urlType == "publish"){
                this.$router.push({path: '/publish',query:{url: this.goUrl}});
            }else if(this.urlType == "home"){
                this.$router.push({path: '/home'});
            }else{
                this.$router.push({path: '/mine'});
            }
        },
    },
    created() {

    },
    mounted() {
        //截取Url里面的参数
        function GetRequest() {
            var url = location.search; //获取url中"?"符后的字串
            // alert(url);
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                // alert(str);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        var request = new Object();
        request = GetRequest();
        this.urlId = request['id'];
        this.urlPrice = request['price'];
        this.urlType = request['urlType'];
        this.goUrl = request['url'];

        this.imgCode();

    },
    watch: {
        // 手机号监听
        phoneVal(){
            if(this.imgCodeTxt.length == 4 && this.phoneVal.length == 13){
                this.chengaColor = true;
            }else{
                this.chengaColor = false;
            }
        },
        // 图片验证码监听
        imgCodeTxt(){
            if(this.imgCodeTxt.length == 4 && this.phoneVal.length == 13){
                this.chengaColor = true;
            }else{
                this.chengaColor = false;
            }
        }
    }
}
</script>

<style scoped lang="scss">

input::-webkit-input-placeholder{
    color: #9f9fa8;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: #9f9fa8;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: #9f9fa8;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color: #9f9fa8;
}

/*浮动*/
.pull-right{
    float: right;
}
.pull-left{
    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

.loginMain{
    width: 6.9rem;
    height: 100vh;
    background: #fff;
    margin: 0 auto;
    padding: 0 .3rem;
    h2{
        font-size: .44rem;
        color: #363636;
        margin-top: .8rem;
        font-weight: 600;
    }
    h5{
        font-size: .24rem;
        color: #9f9fa8;
        margin-top: .2rem;
    }
}
.nav{
    width: 6.9rem;
    height: 1rem;
}
.nav a{
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.navBack{
    width: 0.2rem;
    height: 0.37rem;
    margin-top: 0.3rem;
}
.navTitle{
    height: 1rem;
    width: 6.2rem;
    line-height: 1rem;
    font-size: 0.38rem;
    color: #fff;
    text-align: center;
    float: left;
}
.dInput{
    width: 6.9rem;
    margin-top: .3rem;
    input{
        height: .4rem;
        font-size: 0.3rem;
        color: #363636;
        line-height: .4rem;
    }
    .input1{
        border-bottom: 1px solid #e7e7e7;
        position: relative;
        padding-bottom: .12rem;
        input{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            width: 5rem;
        }
        .closeBtn{
            width: .32rem;
            height: .32rem;
            position: absolute;
            right: 1.8rem;
            top: .28rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
    }
    .input2{
        width: 6.9rem;
        border-bottom: 1px solid #e7e7e7;
        padding-bottom: .3rem;
        position: relative;
        input{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            width: 6.9rem;
        }
    }
}

.btns{
    width: 1.8rem;
    height: .88rem;
    line-height: .88rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    font-size: 0.3rem;
    color: #666;
    background: rgba(0,0,0,0);
    text-align: right;
}
.codeColor{
    color: #2f7af7;
}
.btn{
    margin-top: .6rem;
    text-align: center;
}
.btn p{
    font-size: 0.26rem;
    line-height: 0.22rem;
    color: #fff;
}
.btn .login-btn{
    width: 6.4rem;
    height: 0.88rem;
    display: block;
    margin: 0.2rem auto;
    background: #2f7af7;
    border-radius: 0.44rem;
    font-size: 0.34rem;
    line-height: 0.88rem;
    color: #fff;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}

.codeImgStyle{
    position: absolute;
    right: 0;
    top: 0;
    img{
        width: 1.8rem;
        height: .5rem;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue